(function () {
  'use strict';

  // Matches U+0300-U+036F (combining diacritical marks). Built from char
  // codes instead of a regex literal to avoid editor/encoding pipelines
  // that mangle raw combining-mark characters in source files.
  var DIACRITIC_MARKS = new RegExp(String.fromCharCode(0x5b, 0x5c, 0x75, 0x30, 0x33, 0x30, 0x30, 0x2d, 0x5c, 0x75, 0x30, 0x33, 0x36, 0x66, 0x5d), 'g');

  function normalize(value) {
    return value
      .normalize('NFD')
      .replace(DIACRITIC_MARKS, '')
      .toLowerCase()
      .trim();
  }

  function initSearch() {
    var input = document.getElementById('PthFcSearchInput');
    if (!input) return;

    var grid = document.getElementById('product-grid');
    var emptyState = null;

    function ensureEmptyState() {
      if (emptyState) return emptyState;
      emptyState = document.createElement('div');
      emptyState.className = 'pth-fc__search-empty';
      emptyState.hidden = true;
      emptyState.setAttribute('role', 'status');
      emptyState.innerHTML =
        '<p>Nic sa nenašlo.</p>' +
        '<button type="button" class="pth-fc__search-empty-clear link underlined-link">Vymazať hľadanie</button>';
      grid.insertAdjacentElement('afterend', emptyState);
      emptyState
        .querySelector('.pth-fc__search-empty-clear')
        .addEventListener('click', function () {
          input.value = '';
          applyFilter('');
          input.focus();
        });
      return emptyState;
    }

    function applyFilter(rawQuery) {
      if (!grid) return;
      var items = grid.querySelectorAll(':scope > li.grid__item');
      var query = normalize(rawQuery);
      var visibleCount = 0;

      items.forEach(function (item) {
        if (!query) {
          item.classList.remove('pth-fc-hide');
          visibleCount++;
          return;
        }
        var titleEl = item.querySelector('.card__heading, .full-unstyled-link');
        var title = titleEl ? normalize(titleEl.textContent) : '';
        var matches = title.indexOf(query) !== -1;
        item.classList.toggle('pth-fc-hide', !matches);
        if (matches) visibleCount++;
      });

      var empty = ensureEmptyState();
      empty.hidden = !(query && visibleCount === 0);
    }

    var debounceTimer = null;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var value = input.value;
      debounceTimer = setTimeout(function () {
        applyFilter(value);
      }, 120);
    });

    // Native facet/sort changes morph #product-grid; re-apply the current
    // search term so it survives the re-render instead of being wiped.
    if (grid && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        if (input.value) applyFilter(input.value);
      });
      observer.observe(grid, { childList: true });
    }
  }

  // Proxy the brand "Filtre" button to the native mobile facets drawer so
  // the sheet keeps using Dawn's own facets.js open/close logic untouched.
  function initFilterButtonProxy() {
    var button = document.getElementById('PthFcFilterBtn');
    if (!button) return;
    button.addEventListener('click', function () {
      var summary = document.querySelector('#main-collection-filters .mobile-facets__wrapper summary');
      if (summary) summary.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSearch();
      initFilterButtonProxy();
    });
  } else {
    initSearch();
    initFilterButtonProxy();
  }
})();
